import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

import TeamPlans from 'components/TeamPlans/TeamPlans';

export const StyledTeamPlans = styled(TeamPlans).withConfig({
  shouldForwardProp: () => true,
})`
  padding: 48px 0px;

  ${QUERIES.largeTabletAndUp} {
    padding: 48px;
  }
`;
